import './CompensationHistoryIFS.scss';
import { useCompensationHistoryIFS } from './useCompensationHistoryIFS';
import { HISTORY_VIEW } from '../../constants/common';
import AppLoader from '../AppCommon/AppLoader/AppLoader';
import ConfirmationPopUp from '../ConfirmationPopUp/ConfirmationPopUp';
import { AppNotifications } from '../AppNotifications/AppNotifications';
import CompensationHistoryGridResults from '../CompensationHistoryGridResults/CompensationHistoryGridResults';
import { NavigateFunction } from 'react-router-dom';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';

interface Props {
    navigate: NavigateFunction;
}

const CompensationHistoryIFS = ({
    navigate
}: Props) => {
    const {
        historyContext,
        compensationVouchers,
        rows,
        showPopUp,
        setShowPopUp,
        showCompensationCodes,
        t
    } = useCompensationHistoryIFS();


    return (
        historyContext.loading.history ? (
            <AppLoader />
        ) : (
            <div className="c-comp-hist-ifs">
                {compensationVouchers && compensationVouchers.length && (
                    <ConfirmationPopUp 
                        compensationVouchers={compensationVouchers} 
                        showPopUp={showPopUp} 
                        hidePopUp={() => setShowPopUp(false)}
                    />
                )}
                <div className="c-comp-hist-ifs__content">
                    <AppNotifications 
                        style={{ marginBottom: '3rem' }}
                    />
                    <h1 className="h-title">{t('titles.history.ifs')}</h1>
                    <h1 className="h-title-mobile">{t('titles.history.mobile')}</h1>
                    {/* Only show refresh button if there is history data */}
                    {rows && rows.length > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1rem' }}>
                            <Button
                                variant="outlined"
                                size="large"
                                startIcon={<RefreshIcon />}
                                onClick={historyContext.getIFSHistory}
                                className="refresh-btn-blue-link"
                            >
                                {t('buttons.refresh') || 'Refresh'}
                            </Button>
                        </div>
                    )}
                    {rows && rows.length ? (
                        <>
                            <CompensationHistoryGridResults 
                                handleOnClickSearch={() => {}}
                                rows={rows}
                                navigate={navigate}
                                historyView={HISTORY_VIEW.ifs}
                                showCompensationCodes={showCompensationCodes}
                            />
                        </>
                    ) : <p className="label-no-hist">{t('labels.noHistory')}</p>}      
                </div>
            </div>
        )
    );
};

export default CompensationHistoryIFS;

